import React from "react";
import classes from "./AsttButtonLight.module.css";

const AsttButtonLight = (props) => {
  return (
    <button
      onClick={props.onClick}
      className={`${classes.button} ${props.className}`}
      style={props.style}
      type={props.type || "button"}>
      {props.children}
    </button>
  );
};

export default AsttButtonLight;
